window.Vue = require('vue');
import ProgramBox from './components/ProgramBox.vue';

Vue.component('program-box', ProgramBox);

var vm = new Vue({
    el: '#programs-list',
});

window.addEventListener('popstate', function (e) {

    if(e.state) {

        $('input[name^="programtype"]').prop('checked', false);
        $('input[name^="organizers"]').prop('checked', false);
        $('input[name^="cast"]').prop('checked', false);
        
        e.state.forEach(element => {
            $('input[name="'+element.name+'"]').prop('checked', true);
        });
        vm.$refs.programbox.ajax_filter_programs();
    }
});

$( document ).ready(function() {
    jQuery.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': jQuery('meta[name="csrf-token"]').attr('content')
        }
    });

    //szűrők menü
    //$("#filter-menu").hide();
    $("#filter-button, #filter-trigger").click(function(){
        $("#filter-menu").toggle( "slide" );
        
    });
    $(".close-filtermenu .fas").click(function(){
        $("#filter-menu").toggle( "slide" );
        
    }); 

    //szűrősáv fix
    $(document).scroll(function(){
        var scrollTop     = $(window).scrollTop();
        var elementOffset = $('#filterlane').offset().top;
        var distance      = (elementOffset - scrollTop);

        var headerHeight = $(".header").height();
        
        if( distance <= 0 ){
            $("#filterlane").addClass("topfix");
        }
        if( scrollTop <= headerHeight ){
            $("#filterlane").removeClass("topfix");
        }
    });

    //overlay menü
    //$("#menu_overlay").hide();
    $("#hamburger_close").hide();
    $("#hamburger_open").click(function(){
        $("#menu_overlay").slideDown("slow");
        $("#hamburger_close").show();
    });

    $("#hamburger_close").click(function(){
        $("#menu_overlay").slideUp("slow");
        $("#hamburger_close").hide();
    });

    $('#szures-button').on('click', function (e) {
        e.preventDefault();

        var form = $(this).parent();
        var data = form.find('input[name!=_token]'); 
        var url = '/programok';

        if(data.serialize() != '') {
            url += '?' + data.serialize();
        }

        if(!location.pathname.match(/programok/gi)) {
            history.pushState(data.serializeArray(), '', url);
            location.href = url;
        }
        else {
            history.pushState(data.serializeArray(), '', url);

            vm.$refs.programbox.ajax_filter_programs();
        }
    });

    $('.organizers_programs_link').on('click', function (e) {
        e.preventDefault();

        var input_name = $(this).attr('id');

        $('#filter-form input[name="'+input_name+'"]').prop('checked', true);

        $('#szures-button').trigger('click');
    });

    //fejléc méret
    if ($("body").hasClass("fooldal")) {
        var header = document.getElementById("fooldal_header");
        var heightt = $(window).height();

        header.style.height = heightt + 'px';
    }
});

//fejléc méret
$(window).on('resize', function(){
    if ($("body").hasClass("fooldal")) {
        var header = document.getElementById("fooldal_header");
        var heightt = $(window).height();
    
        header.style.height = heightt + 'px';
    }
});
